<template>
  <div class="flex justify-center relative -left-2">
    <Checkbox
      v-model="isChecked"
      class="datatable-checkbox"
      :disabled="disabled"
    />
  </div>
</template>

<script>
// TODO: We should eventually get rid of this component in favor of DatatableV3 checkbox functionality
import { EventBus } from "@/lib/event_bus.js";

import Checkbox from "@/components/Checkbox.vue";

export default {
  components: {
    Checkbox
  },
  props: {
    value: {
      type: [Number, String],
      default: null
    },
    checked: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    multiselect: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isChecked: this.checked
    };
  },
  watch: {
    isChecked(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.handleChange(newValue);
      }
    }
  },
  mounted() {
    EventBus.$on("datatable-checkbox-select-all", this.handleSelectAll);
    if (this.multiselect) {
      EventBus.$on("datatable-reset-selected-values", this.handleReset);
    }
  },
  beforeUnmount() {
    EventBus.$off("datatable-checkbox-select-all", this.handleSelectAll);
    if (this.multiselect) {
      EventBus.$off("datatable-reset-selected-values", this.handleReset);
    }
  },
  methods: {
    handleChange(checked) {
      EventBus.$emit("datatable-checkbox-change", {
        value: this.value,
        checked
      });
    },
    handleSelectAll(value, checked) {
      // Handles select all changes on a page
      if (value.toString() === this.value.toString()) {
        this.isChecked = checked;
      }
    },
    handleReset() {
      // Handles datatable data changes when the
      // row value is not provided. Hard resetsa all checkboxes
      // Used when searching, filtering, paging table
      this.isChecked = false;
    }
  }
};
</script>

<style lang="scss">
.datatable-checkbox {
  margin: 0 !important;
  font-size: 0.5rem;
  justify-content: center !important;
  padding: 0 !important;
  .checkbox-container {
    margin-right: 0 !important;
    i {
      transform: translateY(2px);
    }
  }
}
</style>
